/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect, useMemo, Fragment, useRef} from "react";
import moment, { Moment } from "moment";
// import _ from 'lodash';

import {useAppSelector, useAppDispatch} from "../../app/hooks";
import {fetchAlertMapDayAction, selectAlertMap} from "../alertMap/alertMapSlice";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Checkbox from "@mui/material/Checkbox";
import {/*Backdrop, */Divider, FormControlLabel, FormGroup, Switch, TableHead,/* Theme,*/ Typography, Alert} from "@mui/material";
import {alpha, styled} from "@mui/material/styles";
import {red, yellow} from "@mui/material/colors";
// import {Modal} from "@mui/base/Modal";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CalendarPicker, PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import 'moment/locale/fr';

import "./D4Weather2.css";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import AlertTable from './AlertTable'

import {AlertItemCheckBoxType} from "../../types";

import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import AlertItemCheckbox from "./AlertItemCheckbox";
import "react-datepicker/dist/react-datepicker.css";

import AppBar from "../address/AppBar";
import AlertAccordionList from "./AlertAccordionList";

import useMapboxHandler, { UseMapboxHandlerReturn } from "./hooks/useMapboxHandler";
import useAlertFilters, { UseAlertFiltersReturn } from "./hooks/useAlertFilters";

import ReactJson from 'react-json-view'

const drawerWidth = 350;

// Configuration for API calls
const isFeatureCollection: boolean = true;

// Alert level filter functions - filter alerts based on their severity level
const filterYellow: (feature: any) => boolean = (feature: any) => feature.properties.level === "JAUNE" || feature.properties.level === "Dégradé";
const filterOrange: (feature: any) => boolean = (feature: any) => feature.properties.level === "ORANGE" || feature.properties.level === "Mauvais";
const filterRed: (feature: any) => boolean = (feature: any) => feature.properties.level === "ROUGE" || feature.properties.level === "Très mauvais" || feature.properties.level === "Extrêmement mauvais";

const RedSwitch = styled(Switch)(({theme}) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: red[600],
        "&:hover": {
            backgroundColor: alpha(red[600], theme.palette.action.hoverOpacity),
        },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: red[600],
    },
}));

const YellowSwitch = styled(Switch)(({theme}) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: yellow[600],
        "&:hover": {
            backgroundColor: alpha(yellow[600], theme.palette.action.hoverOpacity),
        },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: yellow[600],
    },
}));

interface CustomPickerDayProps extends PickersDayProps<Moment> {
    dayIsBetween: boolean;
    isFirstDay: boolean;
    isLastDay: boolean;
}

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) =>
        prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
})<CustomPickerDayProps>(({ theme, dayIsBetween, isFirstDay, isLastDay }) => ({
    ...(dayIsBetween && {
        borderRadius: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.dark,
        },
    }),
    ...(isFirstDay && {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    }),
    ...(isLastDay && {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    }),
})) as React.ComponentType<CustomPickerDayProps>;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{
                display: value === index ? "block" : "none",
                height: "100%",
                overflow: "auto"
            }}
            {...other}
        >
            {children}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function D4Weather() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    // Redux state for alert data
    const alertMap = useAppSelector(selectAlertMap);
    
    // Filtered alert data based on user selections
    const [filteredData, setFilteredData] = useState<any>();

    // const [startDate, setStartDate] = useState(moment());
    // const [endDate, setEndDate] = useState(moment());

    // Date selection state - current and validated (after search)
    const [selectedDate, setSelectedDate] = useState<Moment>(moment().startOf('day'));
    const [previsouSelectedDate, setPreviousSelectedDate] = useState<Moment>(moment().startOf('day'));

    // Alert level filter switches state
    const [isCheckedYellow, setIsCheckedYellow] = useState<boolean>(true);
    const [isCheckedOrange, setIsCheckedOrange] = useState<boolean>(true);
    const [isCheckedRed, setIsCheckedRed] = useState<boolean>(true);
    
    // Yellow alert loading and validation state
    const [withYellow, setWithYellow] = useState<boolean>(false);
    const [previousWithYellow, setPreviousWithYellow] = useState<boolean>(false);
    
    // Date range selection state (current and validated)
    const [withPlusMinusOneDay, setWithPlusMinusOneDay] = useState<boolean>(false);
    const [previousWithPlusMinusOneDay, setPreviousWithPlusMinusOneDay] = useState<boolean>(false);
    
    // Active filter functions based on user selections
    const [selectedFilter, setSelectedFilter] = useState<((feature: any) => boolean)[]>([filterYellow, filterOrange, filterRed]);
    // const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    // Alert filters management - using custom hook for centralized filter state
    const {
        listCheckBox,
        allChecked,
        setListCheckBox,
        handleAllCheckboxChange,
        handleAlertTypeFilterChanged,
        handleExclusiveSelection,
        updateAvailableTypes,
    }: UseAlertFiltersReturn = useAlertFilters();

    // Mapbox integration hook for weather alerts visualization
    const {mapRef, alert, initMapWeatherRisk, onLoadMapWeather, handleMultipleLayersAlert, selectedPostalCode}: UseMapboxHandlerReturn =
        useMapboxHandler(listCheckBox, setListCheckBox);

    // State for selected alert from table
    const [selectedTableAlert, setSelectedTableAlert] = useState<any>(null);

    // Handler for alert selection from table
    const handleTableAlertSelect = (alert: any) => {
        setSelectedTableAlert(alert);
    };

    // State to track if a search has been performed
    const [hasSearched, setHasSearched] = useState<boolean>(false);
    
    // State to track parameters of the last failed request
    const [lastFailedRequestParams, setLastFailedRequestParams] = useState<{
        date: Moment;
        withPlusMinusOneDay: boolean;
        withYellow: boolean;
    } | null>(null);
    
    // State to track if a request succeeded after a failure (to reset the retry state)
    const [hasSucceededAfterFailure, setHasSucceededAfterFailure] = useState<boolean>(false);

    // Update available alert types when alert data changes
    useEffect(() => {
        if (alertMap.value && alertMap.value.features) {
            const types = new Set<string>();
            alertMap.value.features.forEach((feature: any) => {
                types.add(feature.properties.type);
            });
            updateAvailableTypes(Array.from(types));
        } else {
            updateAvailableTypes([]);
        }
    }, [alertMap.value, updateAvailableTypes]);

    // Synchronize map layers with filter state when map is ready
    useEffect(() => {
        if (!mapRef.current || !mapRef.current.isStyleLoaded()) {
            return;
        }
        
        // Use handleMultipleLayersAlert for better performance
        const layerUpdates = listCheckBox.map((item: AlertItemCheckBoxType) => ({
            layerId: item.id,
            isChecked: item.isShow
        }));
        handleMultipleLayersAlert(layerUpdates);
    }, [listCheckBox, handleMultipleLayersAlert]);

    // Reset table selection when map alert changes (user clicked on map)
    useEffect(() => {
        if (alert && alert.length > 0) {
            setSelectedTableAlert(null);
        }
    }, [alert]);

    // Use alert from map or table, with table taking precedence
    const displayAlert = selectedTableAlert || alert;

    // Custom handler for alert type filter changes that updates both map and state
    const handleAlertTypeFilterChangedWithMap = (layerId: string, isChecked: boolean) => {
        // Update the map layer visibility
        handleMultipleLayersAlert([{layerId, isChecked}]);
        // Update the filter state
        handleAlertTypeFilterChanged(layerId, isChecked);
    };

    // Custom handler for exclusive selection that updates both map and state
    const handleExclusiveSelectionWithMap = (layerId: string) => {
        // Update all map layers based on exclusive selection
        const layerUpdates = listCheckBox.map((item: AlertItemCheckBoxType) => ({
            layerId: item.id,
            isChecked: item.id === layerId
        }));
        handleMultipleLayersAlert(layerUpdates);
        
        // Update the filter state
        handleExclusiveSelection(layerId);
    };

    // Custom handler for "all" checkbox that updates both map and state
    const handleAllCheckboxChangeWithMap = () => {
        // Don't allow to uncheck all filters when they are all checked
        if (allChecked) {
            return;
        }
        
        // Update all map layers based on available types in one operation
        const layerUpdates = listCheckBox.map((item: AlertItemCheckBoxType) => ({
            layerId: item.id,
            isChecked: availableTypes.includes(item.type)
        }));
        handleMultipleLayersAlert(layerUpdates);
        
        // Update the filter state
        handleAllCheckboxChange();
    };

    // Initial setup: initialize map only (no API call on mount)
    useEffect(() => {
        initMapWeatherRisk(mapRef);
        if (mapRef.current) {
            onLoadMapWeather(mapRef);
        }
        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
            }
        };
    }, []);

    // useEffect(() => {
    //     dispatch(fetchAlertMapDayAction(
    //         isFeatureCollection,
    //         selectedDate.clone().subtract(1, 'day').utc().format("YYYY-MM-DD"),
    //         selectedDate.clone().add(1, 'day').utc().format("YYYY-MM-DD")
    //     ));
    // }, [selectedDate]);

    // Handle search button click - validate parameters and fetch new data
    const handleSearchButtonClicked = (event: any) => {
        // Mark that a search has been performed
        setHasSearched(true);
        
        // Update validated state with current selections
        setPreviousWithYellow(withYellow);
        setPreviousWithPlusMinusOneDay(withPlusMinusOneDay);
        setPreviousSelectedDate(selectedDate.clone());
        
        // Calculate date range based on +/- 1 day setting
        const startDate = withPlusMinusOneDay 
            ? selectedDate.clone().subtract(1, 'day').utc().format("YYYY-MM-DD")
            : selectedDate.clone().utc().format("YYYY-MM-DD");
        const endDate = withPlusMinusOneDay 
            ? selectedDate.clone().add(1, 'day').utc().format("YYYY-MM-DD")
            : selectedDate.clone().utc().format("YYYY-MM-DD");
            
        dispatch(fetchAlertMapDayAction(
            isFeatureCollection,
            startDate,
            endDate,
            withYellow ? true : undefined
        ));
    }
    
    // Track failed request parameters when an error occurs (only on new errors, not when params change)
    const prevErrorRef = useRef<any>();
    useEffect(() => {
        // Only save params when a NEW error occurs (not when params change while error exists)
        if (alertMap.error && prevErrorRef.current !== alertMap.error) {
            setLastFailedRequestParams({
                date: selectedDate.clone(),
                withPlusMinusOneDay,
                withYellow
            });
            setHasSucceededAfterFailure(false);
            prevErrorRef.current = alertMap.error;
        }
        // Clear error ref when error is cleared
        if (!alertMap.error) {
            prevErrorRef.current = undefined;
        }
    }, [alertMap.error, selectedDate, withPlusMinusOneDay, withYellow]);
    
    // Reset failed request tracking when a request succeeds after a failure
    useEffect(() => {
        if (alertMap.status === 'idle' && alertMap.value && alertMap.error === undefined) {
            // If we had a failed request and now we have success, check if it's a successful retry
            if (lastFailedRequestParams) {
                // Check if current params match the failed request
                const paramsMatch = withYellow === lastFailedRequestParams.withYellow &&
                                   withPlusMinusOneDay === lastFailedRequestParams.withPlusMinusOneDay &&
                                   selectedDate.isSame(lastFailedRequestParams.date, 'day');
                
                // Clear the failed request params if current params match (successful retry)
                if (paramsMatch) {
                    setLastFailedRequestParams(null);
                    setHasSucceededAfterFailure(true);
                }
            }
        }
    }, [alertMap.status, alertMap.value, alertMap.error, lastFailedRequestParams, selectedDate, withPlusMinusOneDay, withYellow]);
    
    // Note: We don't clear lastFailedRequestParams when params change
    // This allows the button to show "Réessayer" when user returns to failed request params
    // It will only be cleared when:
    // 1. A request succeeds with the same params (handled above)
    // 2. A new error occurs with different params (which will replace lastFailedRequestParams)

    // Check if search parameters have changed since last validation
    const didSearchValueChanged = function() {
        // If no search has been performed yet, button should be active
        if (!hasSearched) {
            return true;
        }
        // If there's an error, button should be active to allow retry
        if (alertMap.error) {
            return true;
        }
        // After a search, button is active only if parameters changed
        const didChange = withYellow !== previousWithYellow || 
                         withPlusMinusOneDay !== previousWithPlusMinusOneDay || 
                         !selectedDate.isSame(previsouSelectedDate);
        return didChange;
    }
    
    // Check if current parameters match the last failed request
    const isCurrentParamsEqualToFailedRequest = function(): boolean {
        if (!lastFailedRequestParams) {
            return false;
        }
        return withYellow === lastFailedRequestParams.withYellow &&
               withPlusMinusOneDay === lastFailedRequestParams.withPlusMinusOneDay &&
               selectedDate.isSame(lastFailedRequestParams.date, 'day');
    }
    
    // Determine button label based on error state and parameters
    const getButtonLabel = function(): string {
        // If current params match a failed request (whether there's currently an error or not), show "Réessayer"
        // This handles the case where user changes params after an error, then comes back to the failed params
        if (isCurrentParamsEqualToFailedRequest()) {
            return t("weatherScreen.retryLabel");
        }
        // Otherwise show "Rechercher"
        return t('searchLabel');
    }

    // Main filtering effect - applies level filters, type filters, and postal code filter
    const prevFilteredDataRef = useRef<any>();
    useEffect(() => {
        if (alertMap.error) {
            return;
        }
        if (alertMap.value) {
            const filterData = {
                type: alertMap.value.type,
                features: [...alertMap.value.features],
            };

            // First, check if any alert type filters are selected
            const activeAlertTypes = listCheckBox
                .filter((item: AlertItemCheckBoxType) => item.isShow)
                .map((item: AlertItemCheckBoxType) => item.type);

            if (activeAlertTypes.length === 0) {
                // If no alert type filters are selected, return empty array regardless of level filters
                filterData.features = [];
            } else {
                // Apply level filters to features
                if (selectedFilter.length > 0) {
                    filterData.features = filterData.features.filter((feature: any) => 
                        selectedFilter.some((filter: (feature: any) => boolean) => filter(feature))
                    );
                } else {
                    // If no level filters are selected, return empty array
                    filterData.features = [];
                }
                
                // Apply alert type filters to features
                filterData.features = filterData.features.filter((feature: any) => 
                    activeAlertTypes.includes(feature.properties.type)
                );

                // Apply postal code filter if a postal code is selected
                if (selectedPostalCode) {
                    filterData.features = filterData.features.filter((feature: any) => 
                        feature.properties.postal_code === selectedPostalCode
                    );
                }
            }
            
            // Only update if the data has actually changed (compare features length and IDs)
            const prevData = prevFilteredDataRef.current;
            const hasChanged = !prevData || 
                prevData.features?.length !== filterData.features.length ||
                (filterData.features.length > 0 && prevData.features?.[0]?.properties?.id !== filterData.features[0]?.properties?.id);
            
            if (hasChanged) {
                prevFilteredDataRef.current = filterData;
                setFilteredData(filterData);
            }
        } else {
            // If alertMap.value is undefined, leave filteredData as undefined
            if (prevFilteredDataRef.current !== undefined) {
                prevFilteredDataRef.current = undefined;
                setFilteredData(undefined);
            }
        }
    }, [alertMap, selectedFilter, listCheckBox, selectedPostalCode]);

    // Update active filters when alert level switches change
    useEffect(() => {
        const newFilter = [
            isCheckedYellow ? filterYellow : undefined,
            isCheckedOrange ? filterOrange : undefined,
            isCheckedRed ? filterRed : undefined,
        ].filter(Boolean) as ((feature: any) => boolean)[];
        setSelectedFilter(newFilter);
    }, [isCheckedYellow, isCheckedRed, isCheckedOrange]);

    // Update map data source when filtered data changes
    useEffect(() => {
        if (mapRef.current) {
            const alertSource: any = mapRef.current.getSource("alerts");
            if (alertSource) {
                // Always provide a valid GeoJSON object, even if filteredData is undefined
                const validGeoJSON = filteredData || { type: "FeatureCollection", features: [] };
                alertSource.setData(validGeoJSON);
            }
        }
    }, [filteredData]);

    const requestLoading = alertMap.status === "loading";

    // Show info message when no alerts found in filtered results
    // This is centralized at the component level to avoid redundancy
    // Toast: Show warning if no alert types are selected
    useEffect(() => {
        const activeAlertTypes = listCheckBox.filter((item: AlertItemCheckBoxType) => item.isShow);
        const hasNoTypesSelected = activeAlertTypes.length === 0;
        
        if (hasNoTypesSelected) {
            enqueueSnackbar(
                t("weatherScreen.minOneTypeRequired"),
                { variant: "warning" }
            );
        }
    }, [listCheckBox, t, enqueueSnackbar]);

    // Toast: Show warning if filtered alerts are empty
    useEffect(() => {
        // Only show message if:
        // - alertMap.value exists (raw data has been loaded)
        // - filtered data exists and is empty
        if (alertMap.value && filteredData && filteredData.features?.length === 0) {
            enqueueSnackbar(
                t("weatherScreen.noAlertsMessage"),
                { variant: "warning" }
            );
        }
    }, [filteredData, alertMap.value, t, enqueueSnackbar]);

    // Toast: Show error if alert fetch fails
    useEffect(() => {
        if (alertMap.error) {
            enqueueSnackbar(
                t("weatherScreen.fetchError"),
                { variant: "error" }
            );
        }
    }, [alertMap.error, t, enqueueSnackbar]);

    // const handleChangeDateRange = ({startDate, endDate}: {startDate: Date; endDate: Date}) => {
    //     setStartDate(moment(startDate));
    //     setEndDate(moment(startDate).add(2, "days"));
    // };

    // Handle "all" checkbox toggle for alert types
    // const handleAllCheckboxChange = () => {
    //     const toggledState = !allChecked;
    //     setAllChecked(toggledState);

    //     if (toggledState || (!toggledState && listCheckBox.every((item) => item.isShow))) {
    //         const updatedListCheckBoxAlert = listCheckBox.map((item) => ({
    //             ...item,
    //             isShow: toggledState,
    //         }));
    //         updatedListCheckBoxAlert.forEach((item) => {
    //             handleLayerAlert(item.id, toggledState);
    //         });
    //         setListCheckBox(updatedListCheckBoxAlert);
    //     }
    // };

    // Alert level switch handlers
    const handleCheckboxYellow = () => {
        setIsCheckedYellow(!isCheckedYellow);
    };

    const handleCheckboxOrange = () => {
        setIsCheckedOrange(!isCheckedOrange);
    };

    const handleCheckboxRed = () => {
        setIsCheckedRed(!isCheckedRed);
    };

    // Tab management
    const [tabValue, setTabValue] = useState(0);
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue)
    };

    // TODO: this should be out of the component for performance reason
    // and selectedDates props should be used instead of selectedDate state
    const renderWeekPickerDay = (
        date: Moment,
        selectedDates: Array<Moment | null>,
        pickersDayProps: PickersDayProps<Moment>,
    ) => {
        if (!selectedDate) {
          return <PickersDay disableMargin {...pickersDayProps} />;
        }

        if (withPlusMinusOneDay) {
            // Highlight 3-day range when +/- 1 day is enabled
            const start = selectedDate.clone().subtract(1, 'day');
            const end = selectedDate.clone().add(1, 'day');

            const dayIsBetween = date.isBetween(start, end, 'day', '[]');
            const isFirstDay = date.isSame(start, 'day');
            const isLastDay = date.isSame(end, 'day');

            return (
                <CustomPickersDay
                    {...pickersDayProps}
                    disableMargin
                    dayIsBetween={dayIsBetween}
                    isFirstDay={isFirstDay}
                    isLastDay={isLastDay}
                />
            );
        } else {
            // Highlight only selected date when +/- 1 day is disabled
            const isSelected = date.isSame(selectedDate, 'day');
            
            return (
                <PickersDay
                    {...pickersDayProps}
                    disableMargin
                    selected={isSelected}
                />
            );
        }
    };


    // Validated date range for table display (based on last search)
    const previousSelectedDates = useMemo(function() {
        if (previousWithPlusMinusOneDay) {
            return [
                previsouSelectedDate.clone().startOf('day').subtract('1', 'day').toISOString(),
                previsouSelectedDate.clone().startOf('day').toISOString(),
                previsouSelectedDate.clone().startOf('day').add('1', 'day').toISOString(),
            ]
        } else {
            return [
                previsouSelectedDate.clone().startOf('day').toISOString(),
            ]
        }
    }, [previsouSelectedDate, previousWithPlusMinusOneDay]);

    // List of all possible alert types (based on original unfiltered data)
    const allAlertTypes = useMemo(function() {
        if (!alertMap.value) { return []; }
        const types = new Set<string>();
        alertMap.value.features.forEach(function(item: any) {
            types.add(item.properties.type);
        });
        return Array.from(types).sort();
    }, [alertMap.value]);

    // Get available types for filters
    const availableTypes = useMemo(() => {
        return allAlertTypes;
    }, [allAlertTypes]);

    // Calculate alert count by type (based on raw data, not filtered)
    const alertCountByType = useMemo(() => {
        if (!alertMap.value || !alertMap.value.features) {
            return {};
        }
        
        const countMap: { [key: string]: number } = {};
        alertMap.value.features.forEach((feature: any) => {
            const type = feature.properties.type;
            countMap[type] = (countMap[type] || 0) + 1;
        });
        
        return countMap;
    }, [alertMap.value]);

    // Process alert data for table display - group by type, date, and level
    const alertTableData = useMemo(function() {
        if (!filteredData) { return {}; }
        const alertDataMap = filteredData.features.reduce(function(acc: any, item: any) {
            const alert = item.properties;
            if (!acc["byType"][alert.type]) {
                acc["byType"][alert.type] = previousSelectedDates.reduce(function(acc: any, item: any) {
                    acc[item] = {};
                    return acc;
                }, {});
            }

            for (let date of previousSelectedDates) {
                const expectedAtDate = moment.utc(alert.expected_at);
                // TODO: observed end for flood
                const momentDate = moment(date).utc();
                const startAtDate = expectedAtDate.isBetween(momentDate.clone().startOf('day'), momentDate.clone().endOf('day'), 'days', "[]")
                let endAtDate = false, surroundDate = false, stillPresent = false;
                if (alert.estimated_end) {
                    const expectedEndDate = moment.utc(alert.estimated_end);
                    endAtDate = expectedEndDate.isBetween(momentDate.clone().startOf('day'), momentDate.clone().endOf('day'), 'days', "[]")
                    surroundDate = momentDate.isBetween(expectedAtDate, expectedEndDate, 'days', "[]")
                } else if (alert.observed_end) {
                    const expectedEndDate = moment.utc(alert.observed_end);
                    endAtDate = expectedEndDate.isBetween(momentDate.clone().startOf('day'), momentDate.clone().endOf('day'), 'days', "[]")
                    surroundDate = momentDate.isBetween(expectedAtDate, expectedEndDate, 'days', "[]")
                } else {
                    stillPresent = expectedAtDate.isBefore(momentDate); // flood might have expected without expected end or duration if still "occurring"
                }
                const matchDate = (startAtDate || endAtDate || surroundDate || stillPresent )

                if (matchDate) {
                    if (!acc["byType"][alert.type][date][alert.level]) {
                        acc["byType"][alert.type][date][alert.level] = [];
                    }

                    acc["byType"][alert.type][date][alert.level].push(alert);
                }
            }

            return acc;
        }, {byType:{}, byPostalCode: {}});
        return alertDataMap;
    }, [filteredData, previousSelectedDates]);

    const activeAlertTypes = listCheckBox.filter((item: AlertItemCheckBoxType) => item.isShow);
    const hasNoTypesSelected = activeAlertTypes.length === 0;
    
    // Check if filtered data is empty (when raw data exists) - same condition as toast
    const hasNoFilteredAlerts = alertMap.value && filteredData && filteredData.features?.length === 0;

    return (
        <Box sx={{height: "100%", backgroundColor: "white"}}>
            {/* Main application layout with sidebar and content area */}
            {/* <StyledModal open={isModalOpen} onClose={handleModalClose} slots={{backdrop: StyledBackdrop}}>
                <Box sx={style}>
                    <AlertEditor onClose={handleModalClose} />
                </Box>
            </StyledModal> */}
            <Box sx={{paddingTop: 8, display: "flex", height: "100%"}}>
                <CssBaseline />
                <AppBar title={t("applicationMenu.menuItem.data4weather")} position="fixed" sx={{zIndex: (theme: any) => theme.zIndex.drawer + 1}} />
                <Drawer
                    variant="permanent"
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: {width: drawerWidth, boxSizing: "border-box"},
                    }}
                >
                    {/* Request filters section */}
                    <Box sx={{paddingLeft: "12px", paddingRight: "12px", paddingTop: 8, paddingBottom: 4}}>
                        <Typography>{t("weatherScreen.requestFilterLabel")}</Typography>
                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={"fr"}>
                            <CalendarPicker
                                maxDate={moment().add(3, 'days')}
                                date={selectedDate}
                                onChange={(newValue) => {
                                    if (!newValue) { return }
                                    setSelectedDate(newValue);
                                }}
                                renderDay={renderWeekPickerDay}
                                showDaysOutsideCurrentMonth
                            />
                            <Box sx={{display: "flex", alignItems: "center", paddingLeft: 4, paddingRight: 4}}>
                                <Typography sx={{flex: 1, fontSize: 15, textAlign: "right"}}>{t("weatherScreen.plusMinusOneDayLabel")}</Typography>
                                <Checkbox checked={withPlusMinusOneDay} onChange={(event) => setWithPlusMinusOneDay(event.target.checked)}/>
                            </Box>
                            <Box sx={{display: "flex", alignItems: "center", paddingBottom: 2, paddingLeft: 4, paddingRight: 4}}>
                                <Typography sx={{flex: 1, fontSize: 15, textAlign: "right"}}>{t("weatherScreen.loadYellowAlertLabel")}</Typography>
                                <Checkbox checked={withYellow} onChange={(event) => setWithYellow(event.target.checked)}/>
                            </Box>
                            <Box sx={{textAlign: "center"}}>
                                <Button
                                    variant="contained"
                                    disabled={requestLoading || !didSearchValueChanged()}
                                    onClick={handleSearchButtonClicked}
                                    sx={{width: 130}}
                                >
                                    {requestLoading ? <CircularProgress size={24} sx={{ color: "white" }}/> : getButtonLabel()}
                                </Button>
                            </Box>
                        </LocalizationProvider>
                        {/* <DatePickerRange
                            disableEndDate
                            startDate={startDate.toDate()}
                            endDate={endDate.toDate()}
                            onChange={handleChangeDateRange}
                            onNextStartDate={() =>
                                handleChangeDateRange({startDate: startDate.add(1, "days").toDate(), endDate: endDate.toDate()})}
                            onPrevStartDate={() =>
                                handleChangeDateRange({startDate: startDate.subtract(1, "days").toDate(), endDate: endDate.toDate()})
                            }
                        /> */}
                    </Box>
                    <Divider/>
                    {/* Warning messages section */}
                    {(hasNoTypesSelected || hasNoFilteredAlerts) && (
                        <>
                            <Box sx={{paddingLeft: "12px", paddingRight: "12px", paddingTop: 2, paddingBottom: 2}}>
                                {hasNoTypesSelected && (
                                    <Alert severity="warning" sx={{ mb: 1 }}>
                                        {t("weatherScreen.minOneTypeRequired")}
                                    </Alert>
                                )}
                                {hasNoFilteredAlerts && (
                                    <Alert severity="warning" sx={{ mb: 1 }}>
                                        {t("weatherScreen.noAlertsMessage")}
                                    </Alert>
                                )}
                            </Box>
                            <Divider/>
                        </>
                    )}
                    {/* Local filters section */}
                    <Box sx={{paddingLeft: "12px", paddingRight: "12px", paddingTop: 2}}>
                        <Typography>{t("weatherScreen.localFilterLabel")}</Typography>
                        <div id="geocoder" style={{paddingLeft: "12px", paddingRight: "12px", paddingTop: 10}} />
                        <label style={{display: "flex", alignItems: "center", paddingLeft: "12px", paddingTop: "5px", justifyContent: "flex-end"}}>
                            <span style={{flex: 5, fontSize: 15, textAlign: "right"}}>{t("weatherScreen.allLabel")}</span>
                            <Checkbox 
                                style={{flex: 1}} 
                                name="tous" 
                                size="small" 
                                checked={allChecked} 
                                onChange={handleAllCheckboxChangeWithMap}
                                disabled={allChecked} // Désactivé si tous cochés
                            />
                        </label>
                        {listCheckBox.map((item: AlertItemCheckBoxType, index: number) => {
                            return <AlertItemCheckbox 
                                key={`alert_item_${index}`} 
                                item={item} 
                                handleCheckboxChange={handleAlertTypeFilterChangedWithMap} 
                                onLabelClick={handleExclusiveSelectionWithMap}
                                availableTypes={availableTypes}
                                alertCount={alertCountByType[item.type] || 0}
                            />;
                        })}
                    </Box>
                    {/* Alert level filter switches */}
                    <Box sx={{paddingBottom: "10px"}}>
                        <FormGroup sx={{display: "flex", padding: "12px 20px 12px 0", flexDirection: "row", justifyContent: "space-between"}}>
                            <FormControlLabel
                                control={<YellowSwitch size="small" checked={isCheckedYellow} onChange={handleCheckboxYellow} disabled={!previousWithYellow} />}
                                label="Jaune"
                                labelPlacement="start"
                                sx={{ opacity: previousWithYellow ? 1 : 0.5 }}
                            />
                            <FormControlLabel
                                control={<Switch color="warning" size="small" checked={isCheckedOrange} onChange={handleCheckboxOrange} />}
                                label="Orange"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                control={<RedSwitch size="small" checked={isCheckedRed} onChange={handleCheckboxRed} />}
                                label="Rouge"
                                color="warning"
                                labelPlacement="start"
                            />
                        </FormGroup>
                        {/* <div className="buttonCreate">
                            <Button onClick={handleModalOpen} variant='contained' size='small' sx={{backgroundColor: '#1C5782', fontWeight: 600}}>
                                Créer une alert
                            </Button>
                        </div> */}
                    </Box>
                    {/* <Box sx={{textAlign: "center", paddingBottom: "10px"}}>
                        <Button variant="contained">Apply</Button>
                    </Box> */}
                    <Divider/>
                    <Box sx={{paddingLeft: "12px", paddingRight: "12px", paddingTop: 2}}>
                        <Typography sx={{marginBottom: 2}}>
                            {t("weatherScreen.alertDetails")} {
                                previousWithPlusMinusOneDay 
                                    ? `${previsouSelectedDate.clone().subtract(1, 'day').format("DD/MM/YYYY")} - ${previsouSelectedDate.clone().add(1, 'day').format("DD/MM/YYYY")}`
                                    : previsouSelectedDate.format("DD/MM/YYYY")
                            }
                        </Typography>
                        <AlertAccordionList alertItemList={displayAlert} />
                    </Box>
                </Drawer>
                {/* Main content area with tabs */}
                <Box sx={{flex: 1, display: "flex", flexDirection: "column"}}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs value={tabValue} onChange={handleTabChange}>
                            <Tab label={t('weatherScreen.tabs.map')} {...a11yProps(0)} value={0}/>
                            <Tab label={t('weatherScreen.tabs.alertSummary')} {...a11yProps(1)} value={1}/>
                            <Tab label={t('weatherScreen.tabs.alertTable')} {...a11yProps(2)} value={2}/>
                            <Tab label={t('weatherScreen.tabs.api')} {...a11yProps(3)} value={3}/>
                        </Tabs>
                    </Box>
                    <Box sx={{flex: 1, height: 0, overflow: "hidden"}}>
                        {/* Map tab */}
                        <CustomTabPanel value={tabValue} index={0}>
                            <div className="map-container" id="mapBox" style={{height: "100%"}}/>
                        </CustomTabPanel>
                        {/* Alert summary tab */}
                        <CustomTabPanel value={tabValue} index={1}>
                            <TableContainer sx={{ 
                                paddingLeft: 2, 
                                paddingRight: 2, 
                                backgroundColor: "white"
                            }}>
                                <Table sx={{ tableLayout: "fixed" }}>
                                    <TableHead>
                                        <TableRow key={`byType-header`}>
                                            <TableCell key={`byType-header-0`}>Type</TableCell>
                                            {previousWithPlusMinusOneDay ? (
                                                <>
                                                    <TableCell key={`byType-header-1`} colSpan={4} sx={{textAlign: "center"}}>{previsouSelectedDate.clone().startOf('day').subtract('1', 'day').format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell key={`byType-header-2`} colSpan={4} sx={{textAlign: "center"}}>{previsouSelectedDate.clone().startOf('day').format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell key={`byType-header-3`} colSpan={4} sx={{textAlign: "center"}}>{previsouSelectedDate.clone().startOf('day').add('1', 'day').format("DD/MM/YYYY")}</TableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <TableCell key={`byType-header-1`} colSpan={4} sx={{textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-header-2`} colSpan={4} sx={{textAlign: "center"}}>{previsouSelectedDate.clone().startOf('day').format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell key={`byType-header-3`} colSpan={4} sx={{textAlign: "center"}}></TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                        <TableRow key={`byType-sub-header`}>
                                            <TableCell key={`byType-sub-header-0`} sx={{width: "20%"}}></TableCell>
                                            {previousWithPlusMinusOneDay ? (
                                                <>
                                                    <TableCell key={`byType-sub-header-1`} sx={{width: "6.67%", textAlign: "center"}}>Total</TableCell>
                                                    <TableCell key={`byType-sub-header-2`} sx={{width: "6.67%", textAlign: "center", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e"}}>Jaune</TableCell>
                                                    <TableCell key={`byType-sub-header-3`} sx={{width: "6.67%", textAlign: "center", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e"}}>Orange</TableCell>
                                                    <TableCell key={`byType-sub-header-4`} sx={{width: "6.67%", textAlign: "center", color: isCheckedRed ? "#e53935" : "#9e9e9e"}}>Rouge</TableCell>

                                                    <TableCell key={`byType-sub-header-5`} sx={{width: "6.67%", textAlign: "center"}}>Total</TableCell>
                                                    <TableCell key={`byType-sub-header-6`} sx={{width: "6.67%", textAlign: "center", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e"}}>Jaune</TableCell>
                                                    <TableCell key={`byType-sub-header-7`} sx={{width: "6.67%", textAlign: "center", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e"}}>Orange</TableCell>
                                                    <TableCell key={`byType-sub-header-8`} sx={{width: "6.67%", textAlign: "center", color: isCheckedRed ? "#e53935" : "#9e9e9e"}}>Rouge</TableCell>

                                                    <TableCell key={`byType-sub-header-9`} sx={{width: "6.67%", textAlign: "center"}}>Total</TableCell>
                                                    <TableCell key={`byType-sub-header-10`} sx={{width: "6.67%", textAlign: "center", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e"}}>Jaune</TableCell>
                                                    <TableCell key={`byType-sub-header-11`} sx={{width: "6.67%", textAlign: "center", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e"}}>Orange</TableCell>
                                                    <TableCell key={`byType-sub-header-12`} sx={{width: "6.67%", textAlign: "center", color: isCheckedRed ? "#e53935" : "#9e9e9e"}}>Rouge</TableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <TableCell key={`byType-sub-header-1`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-sub-header-2`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-sub-header-3`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-sub-header-4`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    
                                                    <TableCell key={`byType-sub-header-5`} sx={{width: "6.67%", textAlign: "center"}}>Total</TableCell>
                                                    <TableCell key={`byType-sub-header-6`} sx={{width: "6.67%", textAlign: "center", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e"}}>Jaune</TableCell>
                                                    <TableCell key={`byType-sub-header-7`} sx={{width: "6.67%", textAlign: "center", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e"}}>Orange</TableCell>
                                                    <TableCell key={`byType-sub-header-8`} sx={{width: "6.67%", textAlign: "center", color: isCheckedRed ? "#e53935" : "#9e9e9e"}}>Rouge</TableCell>
                                                    
                                                    <TableCell key={`byType-sub-header-9`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-sub-header-10`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-sub-header-11`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                    <TableCell key={`byType-sub-header-12`} sx={{width: "6.67%", textAlign: "center"}}></TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {
                                        allAlertTypes.map(function(key: string, lineIndex: number) {
                                            const dates = (alertTableData as any)["byType"]?.[key];
                                            
                                            // Check if at least one switch is active for this alert type
                                            const hasActiveSwitches = (previousWithYellow && isCheckedYellow) || isCheckedOrange || isCheckedRed;
                                            
                                            return (
                                                <TableRow key={`byType-row-${lineIndex}`}>
                                                    <TableCell key={`byType-line-${lineIndex}-cell-${key}`} sx={{width: "20%", color: hasActiveSwitches ? "inherit" : "#9e9e9e"}}>{key}</TableCell>
                                                {
                                                    previousWithPlusMinusOneDay ? (
                                                        // 3-day mode - normal display
                                                        previousSelectedDates.map(function(dateKey: string, cellIndex: number) {
                                                            const date = dates?.[dateKey]
                                                            if (!date) {
                                                                return (
                                                                <Fragment key={`fragment-${lineIndex}-${cellIndex}`}>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-total`} sx={{width: "6.67%", textAlign: "right", color: hasActiveSwitches ? "inherit" : "#9e9e9e"}}>0</TableCell>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-yellow`} sx={{width: "6.67%", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e", textAlign: "right"}}>
                                                                        {previousWithYellow && isCheckedYellow ? "0" : "-"}
                                                                    </TableCell>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-orange`} sx={{width: "6.67%", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e", textAlign: "right"}}>
                                                                        {isCheckedOrange ? "0" : "-"}
                                                                    </TableCell>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-red`} sx={{width: "6.67%", color: isCheckedRed ? "#e53935" : "#9e9e9e", textAlign: "right"}}>
                                                                        {isCheckedRed ? "0" : "-"}
                                                                    </TableCell>
                                                                </Fragment>
                                                                )
                                                            }
                                                            const total = Object.keys(date).reduce(function(acc: any, levelKey: any) {
                                                                return acc + date[levelKey].length
                                                            }, 0);
                                                            return (
                                                                <Fragment key={`fragment-${lineIndex}-${cellIndex}`}>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-total`} sx={{width: "6.67%", textAlign: "right", color: hasActiveSwitches ? "inherit" : "#9e9e9e"}}>{total}</TableCell>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-yellow`} sx={{width: "6.67%", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e", textAlign: "right"}}>
                                                                        {previousWithYellow && isCheckedYellow ? (date["JAUNE"] ? date["JAUNE"].length : 0) : "-"}
                                                                    </TableCell>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-orange`} sx={{width: "6.67%", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e", textAlign: "right"}}>
                                                                        {isCheckedOrange ? (date["ORANGE"] ? date["ORANGE"].length : 0) : "-"}
                                                                    </TableCell>
                                                                    <TableCell key={`byType-line-${lineIndex}-cell-${cellIndex}-red`} sx={{width: "6.67%", color: isCheckedRed ? "#e53935" : "#9e9e9e", textAlign: "right"}}>
                                                                        {isCheckedRed ? (date["ROUGE"] ? date["ROUGE"].length : 0) : "-"}
                                                                    </TableCell>
                                                                </Fragment>
                                                            )
                                                        })
                                                    ) : (
                                                        // 1-day mode - display with placeholders
                                                        <>
                                                            {/* Placeholder for previous day */}
                                                            <TableCell key={`byType-line-${lineIndex}-cell-0-total`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            <TableCell key={`byType-line-${lineIndex}-cell-0-yellow`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            <TableCell key={`byType-line-${lineIndex}-cell-0-orange`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            <TableCell key={`byType-line-${lineIndex}-cell-0-red`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            
                                                            {/* Data for selected day */}
                                                            {(() => {
                                                                const date = dates?.[previousSelectedDates[0]]
                                                                if (!date) {
                                                                    return (
                                                                        <>
                                                                            <TableCell key={`byType-line-${lineIndex}-cell-1-total`} sx={{width: "6.67%", textAlign: "right", color: hasActiveSwitches ? "inherit" : "#9e9e9e"}}>0</TableCell>
                                                                            <TableCell key={`byType-line-${lineIndex}-cell-1-yellow`} sx={{width: "6.67%", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e", textAlign: "right"}}>
                                                                                {previousWithYellow && isCheckedYellow ? "0" : "-"}
                                                                            </TableCell>
                                                                            <TableCell key={`byType-line-${lineIndex}-cell-1-orange`} sx={{width: "6.67%", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e", textAlign: "right"}}>
                                                                                {isCheckedOrange ? "0" : "-"}
                                                                            </TableCell>
                                                                            <TableCell key={`byType-line-${lineIndex}-cell-1-red`} sx={{width: "6.67%", color: isCheckedRed ? "#e53935" : "#9e9e9e", textAlign: "right"}}>
                                                                                {isCheckedRed ? "0" : "-"}
                                                                            </TableCell>
                                                                        </>
                                                                    )
                                                                }
                                                                const total = Object.keys(date).reduce(function(acc: any, levelKey: any) {
                                                                    return acc + date[levelKey].length
                                                                }, 0);
                                                                return (
                                                                    <>
                                                                        <TableCell key={`byType-line-${lineIndex}-cell-1-total`} sx={{width: "6.67%", textAlign: "right", color: hasActiveSwitches ? "inherit" : "#9e9e9e"}}>{total}</TableCell>
                                                                        <TableCell key={`byType-line-${lineIndex}-cell-1-yellow`} sx={{width: "6.67%", color: previousWithYellow && isCheckedYellow ? "#fdd835" : "#9e9e9e", textAlign: "right"}}>
                                                                            {previousWithYellow && isCheckedYellow ? (date["JAUNE"] ? date["JAUNE"].length : 0) : "-"}
                                                                        </TableCell>
                                                                        <TableCell key={`byType-line-${lineIndex}-cell-1-orange`} sx={{width: "6.67%", color: isCheckedOrange ? "#ed6c02" : "#9e9e9e", textAlign: "right"}}>
                                                                            {isCheckedOrange ? (date["ORANGE"] ? date["ORANGE"].length : 0) : "-"}
                                                                        </TableCell>
                                                                        <TableCell key={`byType-line-${lineIndex}-cell-1-red`} sx={{width: "6.67%", color: isCheckedRed ? "#e53935" : "#9e9e9e", textAlign: "right"}}>
                                                                            {isCheckedRed ? (date["ROUGE"] ? date["ROUGE"].length : 0) : "-"}
                                                                        </TableCell>
                                                                    </>
                                                                )
                                                            })()}
                                                            
                                                            {/* Placeholder for next day */}
                                                            <TableCell key={`byType-line-${lineIndex}-cell-2-total`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            <TableCell key={`byType-line-${lineIndex}-cell-2-yellow`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            <TableCell key={`byType-line-${lineIndex}-cell-2-orange`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                            <TableCell key={`byType-line-${lineIndex}-cell-2-red`} sx={{width: "6.67%", textAlign: "right"}}></TableCell>
                                                        </>
                                                    )
                                                }
                                                </TableRow>
                                            )
                                        })
                                    }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CustomTabPanel>
                        {/* Alert table tab */}
                        <CustomTabPanel value={tabValue} index={2}>
                            <AlertTable data={filteredData} onAlertSelect={handleTableAlertSelect}/>
                        </CustomTabPanel>
                        {/* API table tab */}
                        <CustomTabPanel value={tabValue} index={3}>
                            <ReactJson 
                                src={filteredData}
                            />
                        </CustomTabPanel>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
